import React from "react";
import "./assets/scss/themes.scss";
import Route from "./Routes";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <React.Fragment>
      <ToastContainer theme="colored" />
      <Route />
    </React.Fragment>
  );
}

export default App;
